// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill';
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import VueScroller from 'vue-scroller';
import MintUI from 'mint-ui';
import 'mint-ui/lib/style.css';
import 'element-ui/lib/theme-chalk/index.css';

import './services/mta';
import './config/fundebug.config';
import './config/sensors-data.config';

import App from './App';
import { routes } from './route';
import dev from './services/dev';
import utils from './services/tools';
import store from './store';
import focus from './lib/directives';
import './plugins/vant';
import './plugins/elementui';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'; // 导入本地化语言

dayjs.locale('zh-cn'); // 使用本地化语言
Vue.use(MintUI);
Vue.use(VueScroller);

Vue.use(VueResource);
utils.init();

Vue.use(VueRouter);
Vue.use(focus);

const router = new VueRouter({ routes });

router.afterEach(() => {
  setTimeout(() => {
    MtaH5.pgv();
  }, 50);
});

Vue.config.debug = Boolean(dev);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
});
